<template>
  <div>
    <div class="alert alert-success" role="alert">
      <h4 class="alert-heading">{{ $t('tabs.end.thanks') }}</h4>
      <p v-html="$t('tabs.end.detail1')"></p>
      <p v-html="$t('tabs.end.detail2')"></p>
      <br>
    </div>
    <div id="ResguardEnquesta">
      <h3 class="text-center">{{ $t('tabs.end.guard') }}</h3>
      <br>
      <table width="100%"  border="1" cellpadding="10px" cellspacing="0px" style="max-width: 550px ;text-align: left; margin-left: auto; margin-right: auto" class="table table-bordered">
        <thead>
        <tr>
          <th style="text-align: right; background: #cccccc" colspan="2"><img  width="300" src="https://resources.tecnocampus.cat/images/tecnocampus_upf.png" alt=""></th>
        </tr>
        <tr>
          <th style="color: #e9ab00;font-size: 2em" colspan="2">{{ $t('tabs.end.guard_title') }}</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <th>Registre: </th>
          <td> <span style="font-size: 1.5em">{{ item.id }} </span></td>
        </tr>
        <tr>
          <th>Data: </th>
          <td>{{ item.created_at }}</td>
        </tr>
        <tr>
          <th>Nom: </th>
          <td>{{ item.name }} {{ item.surname1 }} {{ item.surname2 ? item.surname2 : ''}}</td>
        </tr>
        <tr>
          <th>DNI: </th>
          <td>{{ item.dni }}</td>
        </tr>
        <tr>
          <th>Email: </th>
          <td>{{ item.email }}</td>
        </tr>
        <tr>
          <td colspan="2" style="padding:15px 0; background: #ccc">
            <table width="100%" cellpadding="0" cellspacing="0" border="0" style="text-align: center">
              <tr>
                <td  style="font-size: 8px" class="bold">TecnoCampus</td>
                <td style="font-size: 8px" >Avinguda d'Ernest Lluch, 32</td>
                <td style="font-size: 8px" >08302 Matar&oacute; (Barcelona)</td>
                <td style="font-size: 8px" >Tel. 93 169 65 01</td>
                <td style="font-size: 8px" >Fax. 93 169 65 05</td>
                <td  style="font-size: 8px" class="bold"><a href="http://www.tecnocampus.cat">www.tecnocampus.cat</a></td>
              </tr>
            </table>
          </td>
        </tr>
        </tbody>
      </table>
    </div><!-- end div dades -->

    <div class="text-center">
      <button class="btn btn-warning float-right" @click="printResponse">{{ $t('tabs.end.print') }}</button>
    </div>
  </div>
</template>

<script>
import bus from "@/helpers/event_bus";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "End",
  props: {
    finalObject: {},
    lang: { required:true, default:'ca'}
  },
  data() {
    return {
      item: { id:'', created_at: '', name:'', surname1: '', surname2:'', dni: '', email: '' }
    }
  },
  created() {
    bus.$on('survey-ended',(newvalue) => {
      this.item = newvalue;
      this.$validator.localize(this.lang);
      this.$i18n.locale = this.lang;
    });
  },
  methods:{
    async printResponse(){
      await this.$htmlToPaper("ResguardEnquesta");
    }
  }
}
</script>

<style scoped>

</style>